import { useState, useEffect } from 'react';

import Layout from '@/modules/core/components/Layout';

const fetchTMM = async () => {
  const response = await fetch('https://atb.tn/tmm.php');
  const text = await response.text();

  const parser = new DOMParser();
  const doc = parser.parseFromString(text, 'text/html');
  const tmmValueElement = doc.querySelector('#tmmValue');
  // @ts-ignore
  const tmmValue = tmmValueElement ? parseFloat(tmmValueElement.value) : 7.5;

  return tmmValue;
};
const Simulator = () => {
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  // const [creditType, setCreditType] = useState('');
  const [email, setEmail] = useState('');
  const [pays, setPays] = useState('');
  const [ville, setVille] = useState('');
  const [profession, setProfession] = useState('');
  const [banque, setBanque] = useState('');
  const [amount, setAmount] = useState(0);
  const [duration, setDuration] = useState(10);
  // const [rate, setRate] = useState(0);
  const [monthlyPayment, setMonthlyPayment] = useState<number | null>(null);
  const [tmm, setTmm] = useState(7.5);
  const [isLoading, setIsLoading] = useState(false);
  const [, setIsSubmitted] = useState(false);
  const [consentAccepted, setConsentAccepted] = useState(false);
  const [newsletterOptIn, setNewsletterOptIn] = useState(false);

  useEffect(() => {
    const getTMM = async () => {
      const tmmValue = await fetchTMM();
      setTmm(tmmValue);
    };

    getTMM();
  }, []);
  console.log('tmm', tmm);
  const handleSimulation = async () => {
    setIsLoading(true);

    let annualRate = 0;
    let commission = 0;

    // Determine annual rate and commission based on amount and duration
    if (amount < 100000) {
      if (duration <= 7) {
        annualRate = tmm + 3.5;
      } else if (duration > 7 && duration <= 15) {
        annualRate = tmm + 3.75;
      }
      commission = 0;
    } else if (amount >= 100000 && amount < 200000) {
      if (duration <= 7) {
        annualRate = tmm + 2.2;
      } else if (duration > 7 && duration <= 15) {
        annualRate = tmm + 2.5;
      }
      commission = 20;
    } else if (amount >= 200000 && amount < 500000) {
      if (duration <= 7) {
        annualRate = tmm + 2.0;
      } else if (duration > 7 && duration <= 15) {
        annualRate = tmm + 2.25;
      }
      commission = 30;
    } else if (amount >= 500000) {
      if (duration <= 7) {
        annualRate = tmm + 1.75;
      } else if (duration > 7 && duration <= 15) {
        annualRate = tmm + 2.0;
      }
      commission = 50;
    }

    if (duration > 15 && duration <= 20) {
      annualRate = tmm + 3.75;
    }

    console.log('Annual Rate:', annualRate);

    // Calculate monthly rate and total months
    const monthlyRate = annualRate / 12 / 100;
    const totalMonths = duration * 12;

    // Adjust the loan amount to include commission
    const adjustedAmount = amount + commission;

    // Calculate monthly payment using the corrected formula
    const monthlyP =
      (adjustedAmount * monthlyRate) / (1 - (1 + monthlyRate) ** -totalMonths);

    setMonthlyPayment(monthlyP);
    await fetch('/api/spreadwriter', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        fileId: '1cl63pHAO1yDau48MwtOqgTeKoHlfm_1aX5F1rvfsQTg',
        columns: [
          name,
          phone,
          email,
          pays,
          ville,
          profession,
          banque,
          amount,
          duration,
          monthlyPayment?.toFixed(2),
        ],
      }),
    });
    setIsLoading(false);
    setIsSubmitted(true);
    window.scrollBy({ top: 150, behavior: 'smooth' });
  };

  const isFormValid = () =>
    name.trim() !== '' &&
    phone !== '+216' &&
    phone.trim() !== '' &&
    email.trim() !== '' &&
    email.includes('@') &&
    // creditType !== '' &&
    amount > 0 &&
    consentAccepted;

  const formatNumber = (num: number) =>
    new Intl.NumberFormat('fr-TN').format(num);

  return (
    <div className="w-full lg:mt-0 mt-10 mb-20 lg:mb-40 pt-4 pb-10 px-4 rounded-xl shadow-sm border border-neutral-200">
      <div className="w-full mx-auto">
        {/* Header Section */}
        <div className="text-center mb-6 ">
          <div className="mb-8">
            <img
              src="/media/ATB_1000x300.png"
              alt="Bank Logo"
              className=" md:block mx-auto w-full rounded-2xl"
            />
            {/* <img
              src="https://storage.googleapis.com/caravel-images/unnamed.png"
              alt="Bank Logo"
              className="mx-auto mb-4 w-32 md:hidden"
            /> */}
          </div>

          <div className="space-y-6">
            <h1 className="text-xl lg:text-4xl md:text-5xl font-black text-red-800 leading-tight">
              Simulez votre crédit
            </h1>
            <div className="max-w-4xl mx-auto text-center">
              <p className="text-neutral-700 text-sm lg:text-base leading-relaxed mb-2 ">
                Vous rêvez d&apos;acquérir la maison de vos rêves, et vous avez
                besoin de financement?
              </p>
              <p className="text-neutral-700 text-sm lg:text-base leading-relaxed mb-2 ">
                N&apos;y pensez plus ! Avec les 100 jours SAKAN, l&apos;ATB vous
                propose des crédits immobiliers aux conditions les plus
                avantageuses.
              </p>
              <div className="text-left">
                <ul>
                  <li className="text-neutral-700 text-sm lg:text-base leading-relaxed mb-1">
                    <span className="font-semibold">1.</span> Une durée de
                    traitement rapide.
                  </li>
                  <li className="text-neutral-700 text-sm lg:text-base leading-relaxed mb-1">
                    <span className="font-semibold">2.</span> Une réduction sur
                    la prime d&apos;assurance vie.
                  </li>
                  <li className="text-neutral-700 text-sm lg:text-base leading-relaxed mb-1">
                    <span className="font-semibold">3.</span> Un financement à
                    des taux avantageux et commissions réduites.
                  </li>
                  <li className="text-neutral-700 text-sm lg:text-base leading-relaxed mb-6">
                    <span className="font-semibold">4.</span> Un remboursement
                    flexibles: mensuel ou trimestriel.
                  </li>
                </ul>
              </div>

              <p className="text-sm lg:text-base   font-semibold ">
                Cette simulation est fournie à titre indicatif et est non
                contractuelle.
              </p>
            </div>
          </div>
        </div>

        {/* Main Form Card */}
        <div className="bg-white rounded-2xl shadow-lg overflow-hidden max-w-6xl mx-auto">
          {/* <div className="bg-gradient-to-r from-red-700 to-red-800 px-8 py-6">
            <h2 className="text-base lg:text-2xl font-bold text-white flex items-center">
              Informations de simulation
            </h2>
          </div> */}

          <form
            onSubmit={(e) => {
              e.preventDefault();
              handleSimulation();
            }}
            className="p-4 lg:p-8"
          >
            {/* Personal Information Section */}
            <div className="mb-6">
              {/* <h3 className="text-base lg:text-xl font-semibold text-neutral-800 mb-6 flex items-center">
                Informations personnelles
              </h3> */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="space-y-2">
                  <label className="text-sm lg:text-base block text-neutral-700 font-medium">
                    Nom et Prénom *
                  </label>
                  <input
                    type="text"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    className="placeholder:text-sm w-full px-4 py-3 border border-neutral-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent transition-all duration-200 hover:border-neutral-400"
                    placeholder="Entrez votre nom complet"
                  />
                </div>

                <div className="space-y-2">
                  <label className="text-sm lg:text-base block text-neutral-700 font-medium">
                    Numéro de téléphone *
                  </label>
                  <input
                    type="text"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                    className="placeholder:text-sm w-full px-4 py-3 border border-neutral-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent transition-all duration-200 hover:border-neutral-400"
                    placeholder="+216 XX XXX XXX"
                  />
                </div>

                <div className="space-y-2">
                  <label className="text-sm lg:text-base block text-neutral-700 font-medium">
                    Email *
                  </label>
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="placeholder:text-sm w-full px-4 py-3 border border-neutral-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent transition-all duration-200 hover:border-neutral-400"
                    placeholder="votre.email@exemple.com"
                  />
                  <p className="text-xs lg:text-sm text-neutral-500 mt-1">
                    Votre email sera utilisé pour vous contacter et vous envoyer
                    des informations sur nos produits
                  </p>
                </div>

                <div className="space-y-2">
                  <label className="text-sm lg:text-base block text-neutral-700 font-medium">
                    Pays de résidence
                  </label>
                  <input
                    type="text"
                    value={pays}
                    onChange={(e) => setPays(e.target.value)}
                    className="placeholder:text-sm w-full px-4 py-3 border border-neutral-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent transition-all duration-200 hover:border-neutral-400"
                    placeholder="Tunisie"
                  />
                </div>

                <div className="space-y-2">
                  <label className="text-sm lg:text-base block text-neutral-700 font-medium">
                    Ville
                  </label>
                  <input
                    type="text"
                    value={ville}
                    onChange={(e) => setVille(e.target.value)}
                    className="placeholder:text-sm w-full px-4 py-3 border border-neutral-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent transition-all duration-200 hover:border-neutral-400"
                    placeholder="Tunis"
                  />
                </div>

                <div className="space-y-2">
                  <label className="text-sm lg:text-base block text-neutral-700 font-medium">
                    Profession
                  </label>
                  <input
                    type="text"
                    value={profession}
                    onChange={(e) => setProfession(e.target.value)}
                    className="placeholder:text-sm w-full px-4 py-3 border border-neutral-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent transition-all duration-200 hover:border-neutral-400"
                    placeholder="Votre profession"
                  />
                </div>

                <div className="space-y-2 md:col-span-2">
                  <label className="text-sm lg:text-base block text-neutral-700 font-medium">
                    Banque actuelle
                  </label>
                  <p className="text-xs lg:text-sm text-neutral-500 mt-1">
                    Si c&apos;est l&apos;ATB, veuillez indiquer le nom de
                    l&apos;agence également
                  </p>
                  <input
                    type="text"
                    value={banque}
                    onChange={(e) => setBanque(e.target.value)}
                    className="w-full placeholder:text-sm px-4 py-3 border border-neutral-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent transition-all duration-200 hover:border-neutral-400"
                    placeholder="Nom de votre banque et agence"
                  />
                </div>
              </div>
            </div>

            {/* Credit Information Section */}
            <div className="mb-6">
              {/* <h3 className="text-base lg:text-xl font-semibold text-neutral-800 mb-6 flex items-center">
                Détails du crédit
              </h3> */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* <div className="space-y-2">
                  <label className="text-sm lg:text-base block text-neutral-700 font-medium">
                    Type de crédit *
                  </label>
                  <select
                    value={creditType}
                    onChange={(e) => setCreditType(e.target.value)}
                    className="w-full text-sm lg:text-base px-4 py-3 border border-neutral-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent transition-all duration-200 hover:border-neutral-400 bg-white"
                  >
                    <option value="">Sélectionnez le type</option>
                    <option value="terrain">Acquisition Terrain</option>
                    <option value="logement-neuf">
                      Acquisition Logement Neuf
                    </option>
                    <option value="logement-ancien">
                      Acquisition Logement Ancien
                    </option>
                    <option value="construction">Construction</option>
                    <option value="renovation">Rénovation</option>
                  </select>
                </div> */}

                <div className="space-y-2">
                  <label className="text-sm lg:text-base block text-neutral-700 font-medium">
                    Montant (DT) *
                  </label>
                  <div className="relative">
                    <input
                      type="number"
                      value={amount || ''}
                      onChange={(e) =>
                        setAmount(parseFloat(e.target.value) || 0)
                      }
                      className="placeholder:text-sm w-full px-4 py-3 border border-neutral-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent transition-all duration-200 hover:border-neutral-400 pr-12"
                      placeholder="100,000"
                      min="0"
                      step="1000"
                    />
                    <span className="absolute right-3 top-3 text-neutral-500 font-medium">
                      DT
                    </span>
                  </div>
                  {amount > 0 && (
                    <p className="text-sm text-neutral-600">
                      {formatNumber(amount)} DT
                    </p>
                  )}
                </div>

                <div className="space-y-2">
                  <label className="text-sm lg:text-base block text-neutral-700 font-medium">
                    Durée de remboursement (ans)
                  </label>
                  <div className="relative">
                    <input
                      type="number"
                      value={duration}
                      onChange={(e) =>
                        setDuration(parseInt(e.target.value, 10))
                      }
                      min={1}
                      max={20}
                      className="placeholder:text-sm w-full px-4 py-3 border border-neutral-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent transition-all duration-200 hover:border-neutral-400"
                      placeholder="10"
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* Consent and Newsletter Section */}
            <div className="mb-6 space-y-4">
              {/* Mandatory Consent Checkbox */}
              <div className="flex items-start space-x-3">
                <input
                  type="checkbox"
                  id="consent"
                  checked={consentAccepted}
                  onChange={(e) => setConsentAccepted(e.target.checked)}
                  className="mt-1 w-4 h-4 text-red-600 bg-white border-gray-300 rounded focus:ring-red-500 focus:ring-2"
                />
                <label
                  htmlFor="consent"
                  className="text-sm lg:text-base text-neutral-700"
                >
                  <span className="text-red-600">*</span> J&lsquo;accepte le
                  traitement de mes données personnelles conformément à la
                  politique de confidentialité de l&lsquo;ATB et j&apos;autorise
                  l&apos;ATB à me contacter concernant ma demande de crédit.
                </label>
              </div>

              {/* Optional Newsletter Checkbox */}
              <div className="flex items-start space-x-3">
                <input
                  type="checkbox"
                  id="newsletter"
                  checked={newsletterOptIn}
                  onChange={(e) => setNewsletterOptIn(e.target.checked)}
                  className="mt-1 w-4 h-4 text-red-600 bg-white border-gray-300 rounded focus:ring-red-500 focus:ring-2"
                />
                <label
                  htmlFor="newsletter"
                  className="text-sm lg:text-base text-neutral-700"
                >
                  Je souhaite recevoir la newsletter et les informations
                  commerciales de l&apos;ATB par email
                </label>
              </div>
            </div>

            {/* Submit Button */}
            <div className="text-center">
              <button
                type="submit"
                disabled={!isFormValid() || isLoading}
                className={`mb-6 px-10 py-4 rounded-xl font-semibold text-sm lg:text-base transition-all duration-300 transform ${
                  isFormValid() && !isLoading
                    ? 'bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800 text-white shadow-lg hover:shadow-xl hover:scale-95 focus:ring-4 focus:ring-red-300'
                    : 'bg-neutral-100 text-neutral-400 cursor-not-allowed'
                }`}
              >
                {isLoading ? (
                  <div className="flex items-center">
                    <svg
                      className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                      ></circle>
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                      ></path>
                    </svg>
                    Calcul en cours...
                  </div>
                ) : (
                  <div className="flex items-center justify-center">
                    Simuler mon crédit
                  </div>
                )}
              </button>
            </div>
          </form>
        </div>

        {/* Results Section */}
        {monthlyPayment !== null && (
          <div className="mt-8 transform transition-all duration-500">
            <div className="bg-gradient-to-r from-green-50 to-emerald-50 border-2 border-green-200 rounded-2xl p-8 shadow-lg">
              <div className="text-center mb-6">
                <h2 className="text-base lg:text-xl font-bold text-green-800 mb-2">
                  Résultat de votre simulation
                </h2>
                <p className="text-green-700">
                  Voici le détail de votre crédit immobilier
                </p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="bg-white rounded-xl p-6 text-center shadow-md border border-green-100">
                  <div className="text-lg lg:text-2xl font-bold text-neutral-800 mb-2">
                    {formatNumber(amount)} DT
                  </div>
                  <div className="text-green-600 font-semibold">
                    Montant emprunté
                  </div>
                </div>

                <div className="bg-white rounded-xl p-6 text-center shadow-md border border-green-100">
                  <div className="text-lg lg:text-2xl font-bold text-red-600 mb-2">
                    {formatNumber(parseFloat(monthlyPayment.toFixed(2)))} DT
                  </div>
                  <div className="text-green-600 font-semibold">Mensualité</div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

Simulator.getLayout = function getLayout(page: JSX.Element) {
  return (
    <Layout>
      <Layout.Wide>{page}</Layout.Wide>
    </Layout>
  );
};

export default Simulator;
